import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from './theme'
import { AppProviders } from './providers'
import { router } from './routes'
import { resetDatabase, apiConfig } from './api'
import './i18n' // Initialize i18n
import './index.css'

// Only reset/seed database when using mock API
if (apiConfig.useMockApi) {
  resetDatabase()
}

// DEV only: activate Figma capture bypass when ?__figma_role= is in the URL
// Usage: http://localhost:5173/dashboard?__figma_role=platform_admin
if (import.meta.env.DEV) {
  const { activateFigmaCaptureIfRequested } = await import('./utils/figma-capture')
  activateFigmaCaptureIfRequested()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ThemeProvider>
  </StrictMode>
)
